import { ReactNode } from "react";
import { AdminDrawer, AdminAppBar } from "../components/admin";
import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { useLocation } from "react-router-dom";
import Toolbar from "@mui/material/Toolbar";
import { CssBaseline } from "@mui/material";

type AdminLayoutProps = {
  children: ReactNode; // Esto define el tipo de `children`
  title: string;
};

const drawerWidth = 215;

export const AdminLayout = ({ children, title }: AdminLayoutProps) => {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeItem, setActiveItem] = useState(""); // Estado para rastrear el elemento activo

  // Determina el ítem activo basado en la ruta
  useEffect(() => {
    const currentPath = location.pathname;

    if (currentPath === "/admin/estudiantes-curso-grupo") {
      setActiveItem("EstudiantesGrupo");
    } else if (currentPath === "/admin/estudiantes") {
      setActiveItem("EstudiantesTodos");
    } else if (currentPath.includes("/admin/cursos")) {
      setActiveItem("Cursos");
    } else if (currentPath.includes("/admin/grupos")) {
      setActiveItem("Grupos");
    } else if (currentPath.includes("/admin/sedecorreoscr")) {
      setActiveItem("Sedes Correos");
    } else if (currentPath.includes("/admin/colegios")) {
      setActiveItem("Colegios");
    } else {
      setActiveItem("Inicio");
    }
  }, [location]);

  const handleDrawerClose = () => {
    setMobileOpen(false);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />

      <AdminAppBar
        title={title}
        drawerWidth={drawerWidth}
        handleDrawerToggle={handleDrawerToggle}
      />

      <AdminDrawer
        drawerWidth={drawerWidth}
        mobileOpen={mobileOpen}
        handleDrawerClose={handleDrawerClose}
        activeItem={activeItem} // Pasamos el activeItem al Drawer
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          marginLeft: { sm: `${drawerWidth}px` }, // Asegura espacio en escritorio

          width: { xs: "100%", sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <Toolbar sx={{ display: { sm: "none" } }} />

        {children}
      </Box>
    </Box>
  );
};
